<template>
  <p
    class="nup-countdown"
    :class="isEn ? 'is-en' : ''"
  >
    <span class="nup-countdown__time">{{ text }}</span>
    <span class="nup-countdown__suffix">{{ suffix }}</span>
  </p>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import { getCopy } from '../constants/copy';
import { useCountdown } from '../composables/use-countdown';
import { useNupLang } from '../composables/use-nup-lang';
import { usePageTypeFlag } from '../composables/use-page-type';
const __sfc_main = {};
__sfc_main.props = {
  endAt: {
    type: Number,
    default: 0
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const {
    isEn
  } = useNupLang();
  const {
    text
  } = useCountdown(() => props.endAt || null, () => isEn.value);
  const {
    isPC
  } = usePageTypeFlag();
  const copy = computed(() => getCopy(isEn.value));
  const suffix = computed(() => {
    return isPC.value ? copy.value.countdownPc : copy.value.countdownH5;
  });
  return {
    isEn,
    text,
    suffix
  };
};
export default __sfc_main;
</script>

<style scoped>
.nup-countdown {
  margin: 0 0 36px;
  font-size: 28px;
  line-height: 1.4;
  color: #303030;
  white-space: nowrap;
}

.nup-countdown.is-en {
  white-space: normal;
}

.nup-page.is-h5.is-en .nup-countdown {
  color: #000;
  font-family: 'BR Hendrix', Arial, sans-serif;
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}

.nup-page.is-h5.is-en .nup-countdown__suffix {
  opacity: 0.8;
}

.nup-countdown__time {
  color: #ff6900;
  font-weight: 600;
}

.nup-page.is-pc .nup-countdown {
  margin-bottom: 24px;
  font-size: 24px;
  text-align: center;
}
</style>
